import React from 'react';

import {  Navigate  } from 'react-router-dom';

const PrivateRoute = ({  children }) => {
        // const { isAuthenticated } = useContext(AuthContext);
        // console.log("children",children)
        // console.log(" localStorage.getItem(isAuthenticated)",localStorage.getItem("isAuthenticated"));
        // console.log("local item",sessionStorage.getItem("access_token"));
    let isAuthenticated=sessionStorage.getItem("access_token")
// console.log("isAuthenticated children",isAuthenticated)
    return( (isAuthenticated) ? children : <Navigate to="/login" />);
  };

export default PrivateRoute;
